// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"f95d906d","120":"9144411a","121":"34bbb0d4","143":"c006aa64","159":"cc51d678","202":"4ef42d03","218":"e9a1ad5c","223":"b9417da1","225":"363ffe2b","396":"76e0c65e","770":"159ee38f","797":"b801e9d7","938":"4cf8eaa2"}[chunkId] + ".chunk.js";
};